<!--
 * @FileDescription: 售后订单列表
 * @Author: 陈文景
 * @Date: 2022-11-08 15:23:21
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <div>
    <Web v-if="isPC" />

    <Mobile v-else />
  </div>
</template>

<script>
import Web from './web/index.vue'
import Mobile from './mobile/index.vue'

export default {
  components: {
    Web,
    Mobile
  }
}
</script>
